import { render } from "./MessageThreadList.vue?vue&type=template&id=70bb074a&scoped=true"
import script from "./MessageThreadList.vue?vue&type=script&lang=js"
export * from "./MessageThreadList.vue?vue&type=script&lang=js"

import "./MessageThreadList.vue?vue&type=style&index=0&id=70bb074a&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bb074a"]])

export default __exports__